import { RowNode } from 'ag-grid-community';
import { FilterInterface } from '../components';
import { isRxAdminEnabled } from '../redux/helpers';
import { AnyType } from '../interfaces';
import { formatStatusText } from './ag-grid';

export const dashboardfilterComparator = (
  node: RowNode,
  filter?: FilterInterface,
  statusDescription?: any,
  filterMapping?: any
) => {
  let showNode = false;
  switch (filter?.primaryFilter?.toLowerCase()) {
    case 'actions':
      if (node.data.rxAdminAlert && isRxAdminEnabled()) {
        showNode = node.data.rxAdminAlert;
      } else {
        showNode = node.data.actionAlert || !!node.data.actionAlertCount;
      }
      break;

    case 'updates':
      showNode = node.data.updateAlert || !!node.data.updateAlertCount;
      break;

    case 'pending':
      if (
        filterMapping?.pending
          .map((pending: string) => pending.toLowerCase())
          .includes(node.data.statusText?.toLowerCase())
      ) {
        showNode = true;
      }
      break;

    case 'complete':
      if (
        filterMapping?.completed
          .map((completed: string) => completed.toLowerCase())
          .includes(node.data.statusText?.toLowerCase())
      ) {
        showNode = true;
      }
      break;

    case 'enrollement':
      if (
        filterMapping?.enrollment
          .map((enrollment: string) => enrollment.toLowerCase())
          .includes(node.data.statusText?.toLowerCase()) &&
        node.data.actionAlertCount == 0 &&
        node.data.updateAlertCount == 0
      ) {
        showNode = true;
      }
      break;
    case 'incomplete':
      if (
        node.data.statusText === 'DRAFT_CONSENT_MISSING' ||
        node.data.statusText === 'DRAFT_CONSENT_REQUESTED' ||
        node.data.statusText === 'DRAFT_CONSENT_AVAILABLE' ||
        node.data.statusText === 'DRAFT'
      ) {
        showNode = true;
      }
      break;

    default:
      showNode = true;
  }
  return showNode;
};

export const getStatusDescriptions = (data: AnyType[], typeName: string) => {
  const statusDescriptions: string[] = [
    ...new Set(
      data.reduce((acc: string[], curr: AnyType) => {
        if (curr?.statusText) {
          acc = [...acc, curr.statusText];
        }
        return acc;
      }, [])
    )
  ];
  return statusDescriptions.map((item) => ({ statusDescription: item, __typename: typeName }));
};
